/**
 * Apoio à pré-renderização das páginas públicas.
 *
 * `hasStoredAuthSession` é uma leitura SÍNCRONA do navegador: só olha se existe
 * token do Supabase guardado. Serve para dois lugares:
 *
 * 1. `main.tsx` — decide entre hidratar o HTML pré-renderizado (visitante sem
 *    sessão) ou seguir o caminho de sempre (mãe logada: nada muda).
 * 2. `useAuthSession` — o estado inicial de "verificando sessão" só começa
 *    ligado quando existe token guardado. Sem token não há nada a esperar, e é
 *    isso que permite o HTML estático nascer com o conteúdo já montado.
 *
 * Em dúvida (storage bloqueado, erro), devolve `true` — o caminho de hoje.
 */
export const PRERENDER_ATTR = "data-prerendered";

export function hasStoredAuthSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const ls = window.localStorage;
    for (let i = 0; i < ls.length; i += 1) {
      const key = ls.key(i);
      if (key && key.startsWith("sb-") && key.includes("auth-token")) return true;
    }
    return false;
  } catch {
    return true;
  }
}
